exports.default = "WebpackMultiOutput-/home/runner/work/web/web/static/nls/composable-page-header.js-WebpackMultiOutput";